import React from 'react';
import classNames from 'classnames';

import css from './InstantBookBadge.module.css';

/**
 * InstantBookBadge component for showing instant book availability.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean} props.isInstantBook whether instant book is enabled
 * @returns {JSX.Element|null} badge component showing instant book availability
 */
const InstantBookBadge = props => {
  const { className, rootClassName, isInstantBook } = props;
  
  if (!isInstantBook) {
    return null;
  }
  
  const classes = classNames(rootClassName || css.root, className);

  return (
    <span className={classes}>
      <span className={css.lightning}>⚡</span>
      <span className={css.text}>Instant Book</span>
    </span>
  );
};

export default InstantBookBadge;